import React from "react";
import "../Style/topbar.css";

function TopBarAds() {
  return (
    <div className="tb_ads">
      <div className="tba_secs a">
        <span>How To </span>
        <span>PLACE TARGETED ADS</span>
        <span>on Nairaland</span>{" "}
      </div>
      <div className="tba_secs a">
        <span>How To </span>
        <span>PLACE TARGETED ADS</span>
        <span>on Nairaland</span>{" "}
      </div>
      <div className="tba_secs">
        <span>How To </span>
        <span>PLACE TARGETED ADS</span>
        <span>on Nairaland</span>{" "}
      </div>
    </div>
  );
}

export default TopBarAds;
